import { CustomerSectionContent } from './customer-section-content';
import { CustomerSectionHeaderContent } from './customer-section-header-content';
import { getCustomerSummary } from './get-customer-summary';
import { OrdersSidebarSection } from '../orders-sidebar-section';

/**
 * @param {object} props
 * @param {string} props.salesOrderId
 * @param {string} props.currentFulfillmentPlanId
 * @param {boolean} props.open
 * @param {(isExpanded: boolean) => void} props.onClick
 * @param {object} props.dragHandleProps
 * @param {object} props.shipTo
 * @returns {JSX.Element}
 */
export const CustomerSection = ({ salesOrderId, currentFulfillmentPlanId, open, onClick, dragHandleProps, shipTo }) => {
  const headerContent = <CustomerSectionHeaderContent salesOrderId={salesOrderId} />;

  const sectionContent = <CustomerSectionContent fulfillmentPlanId={currentFulfillmentPlanId} salesOrderId={salesOrderId} />;

  return (
    <OrdersSidebarSection
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      summaryData={getCustomerSummary(shipTo, open)}
      toggleIsExpanded={onClick}
    />
  );
};
